export const BeneficiariesWithPagination = (state) => {
    return state?.beneficiaries?.beneficiaries;
};
export const BeneficiariesIsLoading = (state) => {
    return state?.beneficiaries?.showLoading;
};
